import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import HamsterAnimation from '../../animation/loader';
import ShareToWhatsApp from '../ShareToWhatsApp';
import ConvertToPdfButton from '../DPDF';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import DownloadDocxButton from '../DW';

const Parea = ({ logs, context }) => {
    const [procedurResponse, setProcedureResponse] = useState('');
    const [isLoading, setIsLoading] = useState(false); 
    const { getAccessTokenSilently } = useAuth0();
    const [sharingResponse, setSharingResponse] = useState('');
    useEffect(() => {
      const storedProcedureResponse = localStorage.getItem('procedureResponse');
      console.log("this is the stored procedure response", storedProcedureResponse);
      if (storedProcedureResponse) {
          setProcedureResponse(storedProcedureResponse);
          
      }
      //now for sharedresponse
      const storedSharingResponse = localStorage.getItem('sharingResponse');
      console.log("this is the stored procedure response", storedSharingResponse);
      if (storedSharingResponse) {
          setSharingResponse(storedSharingResponse);
          
      }


  }, []);

    function markdownToWhatsApp(text) {
      //console.log(text);
      let whatsappFormattedText = text;
    
      // Bold: Replace ** or __ with *
      whatsappFormattedText = whatsappFormattedText.replace(/(\*\*|__)(.*?)\1/g, '*$2*');
    
      // Italics: Replace * or _ with _
      whatsappFormattedText = whatsappFormattedText.replace(/(\*|_)(.*?)\1/g, '_$2_');
    
      // Strikethrough: Replace ~~ with ~
      whatsappFormattedText = whatsappFormattedText.replace(/~~(.*?)~~/g, '~$1~');
    
      // Monospace: Replace ``` with ```
      // (Monospace is the same in Markdown and WhatsApp)
      // Title: Replace #, ##, ###, etc., with *
      whatsappFormattedText = whatsappFormattedText.replace(/^(\s*)#+([^\n]*)/gm, '$1*$2*');
      //Notes: Replace [and] with _
      whatsappFormattedText = whatsappFormattedText.replace(/(\[)(.*?)(\])/g, '_$2_');

      whatsappFormattedText = whatsappFormattedText.replace(/\* /g,'*');
      whatsappFormattedText = whatsappFormattedText.replace(/ \*\n/g,'*\n');
      //also for _
      whatsappFormattedText = whatsappFormattedText.replace(/_ /g,'_');
      whatsappFormattedText = whatsappFormattedText.replace(/ _\n/g,'_\n');
      //console.log(whatsappFormattedText);
    
      return whatsappFormattedText;
    }    
    
  
  
      
      
const sendTextResponse = async () => {
        setIsLoading(true);
        if (logs.length !== 0) {
          try {
            console.log("contexto para enviar texto", context);
            const token = await getAccessTokenSilently();
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/print_text`, {
              method: 'POST',
              headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ text: "Sintetiza la siguiente transcripcion de manera clara y sencilla (al ser una transcripción puede contener errores pero el contexto de la trasncripcion es \""+context+"\"). Obligatoriamente Necesito que utilices # títulos, subtítulos, listas, sublistas, todo lo que se te pueda ocurrir:\n"+logs.join(' ') }), // Send the chatResponse2 as a JSON object
            });
      
            if (!response.body) {
              throw Error('Unsupported Response');
            }
      
            const reader = response.body.getReader();
            let chunks = '';
            while (true) {
              const { done, value } = await reader.read();
              if (done) {
                console.log('Completed');
                
                console.log("this is the local stored procedure response", localStorage.getItem('procedureResponse'));
                console.log("this is  procedure response", procedurResponse);
                break;
              }
              chunks += new TextDecoder("utf-8").decode(value);
              const sanitizedHTML = DOMPurify.sanitize(marked.parse(chunks));
                setProcedureResponse(sanitizedHTML);
                setSharingResponse(chunks);
                localStorage.setItem('procedureResponse', sanitizedHTML);
                //now for sharedresponse
                localStorage.setItem('sharingResponse', chunks);
                
            }
          } catch (err) {
            console.log(err);
            setProcedureResponse("ERROR INESPERADO EN EL SERVIDOR, INTENTE ENVIAR TEXTO DE NUEVO");
          }
          finally {
            setIsLoading(false);
          }
        } else {
          console.log('Chat response is empty. Nothing to send.');
        }
      };
const [verpdf, setverpdf] = useState(true);
const ocultar = () => {
    setverpdf(verpdf ? false : true);
  }
      return (
        <>
            {logs.length!==0 && <button className="content-button status-button open" onClick={sendTextResponse} disabled={isLoading}>Enviar texto</button>}
            <div>
                {verpdf && <p className="app-card2__subtext" dangerouslySetInnerHTML={{ __html: localStorage.getItem('procedureResponse') }}></p>}
                
                {isLoading && <HamsterAnimation />}
            </div>
            
            {localStorage.getItem('procedureResponse') && procedurResponse!== '' && verpdf && !isLoading &&
            <div className="content-wrapper-header2">
                <ShareToWhatsApp text={markdownToWhatsApp(sharingResponse)} />
                <ConvertToPdfButton input={procedurResponse} />
                <DownloadDocxButton input={procedurResponse} />
            </div>}
            {localStorage.getItem('procedureResponse') && procedurResponse !== '' && <button className="content-button status-button open" onClick={ocultar}>{verpdf ? "Ocultar" : "Mostrar"}</button>}
        </>
        );
    }
export default Parea;